import React from "react";
import useTradeInModalToggle from "../../hooks/useTradeInModalToggle";
import TradeInAem from "./TradeInAem";
import TradeInAemModalWrapper from "./common/TradeInAemModalWrapper";

const TradeInAemInjectionWrapper = (): JSX.Element | null => {
    const { showInline, showModal, closeModal } = useTradeInModalToggle();

    if (showModal) {
        return (
            <TradeInAemModalWrapper show closeModal={closeModal}>
                <TradeInAem insideModal />
            </TradeInAemModalWrapper>
        );
    }

    if (showInline) return <TradeInAem />;
    return null;
};

export default TradeInAemInjectionWrapper;
